import { useRef, useEffect, useCallback } from 'react';

export interface UseFutebolEventPersistenceReturn {
  lastEventKeyRef:    React.RefObject<string | null>;
  lastIntervalKeyRef: React.RefObject<string | null>;
  onEventoProcessado(key: string): void;
  onIntervalProcessado(key: string): void;
}

/**
 * Persiste em localStorage as últimas chaves de evento/intervalo de futebol
 * processadas, para que reloads (watchdog 04h, crash) não re-exibam eventos
 * já mostrados antes do reload. Limpa as chaves quando o fixtureId muda de
 * um jogo para outro (mas não quando é o mesmo jogo retomado após reload).
 */
export function useFutebolEventPersistence(fixtureId: number | null): UseFutebolEventPersistenceReturn {
  const lastEventKeyRef    = useRef<string | null>(localStorage.getItem('ds:futebol_last_event'));
  const lastIntervalKeyRef = useRef<string | null>(localStorage.getItem('ds:futebol_last_interval'));

  const onEventoProcessado = useCallback((key: string) => {
    lastEventKeyRef.current = key;
    try { localStorage.setItem('ds:futebol_last_event', key); } catch { /* quota */ }
  }, []);

  const onIntervalProcessado = useCallback((key: string) => {
    lastIntervalKeyRef.current = key;
    try { localStorage.setItem('ds:futebol_last_interval', key); } catch { /* quota */ }
  }, []);

  const prevFixtureIdRef = useRef<number | null>(
    Number(localStorage.getItem('ds:futebol_fixture_id') || '0') || null,
  );

  useEffect(() => {
    const novoId = fixtureId;
    if (novoId === null) return;
    if (novoId !== prevFixtureIdRef.current) {
      if (prevFixtureIdRef.current !== null) {
        lastEventKeyRef.current    = null;
        lastIntervalKeyRef.current = null;
        try {
          localStorage.removeItem('ds:futebol_last_event');
          localStorage.removeItem('ds:futebol_last_interval');
        } catch { /* quota */ }
      }
      prevFixtureIdRef.current = novoId;
      try { localStorage.setItem('ds:futebol_fixture_id', String(novoId)); } catch { /* quota */ }
    }
  }, [fixtureId]);

  return { lastEventKeyRef, lastIntervalKeyRef, onEventoProcessado, onIntervalProcessado };
}
